export enum RepliedFilter {
  WithoutReplied = 0,
  WithReplied = 1,
}
